var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Versicherte-Bearbeiten-Popup",
    transform: "translate(-1035.000000, -271.000000)",
    stroke: "#263238",
    className: "toggle",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(360.000000, 236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "x-circle",
    transform: "translate(664.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "x-icon",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 L0,8",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L8,8",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXDark);
export default __webpack_public_path__ + "static/media/x-dark.8e6f9b1c1112ac0930de2ec0eea85f34.svg";
export { ForwardRef as ReactComponent };